import { filter } from 'lodash';
import { Component, OnInit, Input, Output, EventEmitter, HostBinding } from '@angular/core';

import { FeatureProvider } from '@ecap3/core';
@Component({
    selector: 'app-platform-feature-guard',
    templateUrl: './platform-feature-guard.component.html',
    styleUrls: ['./platform-feature-guard.component.scss']
})
export class PlatformFeatureGuardComponent implements OnInit {
    @Input() activatesWith: any[];
    @Output() onCheckedFeatureGuard = new EventEmitter<boolean>();
    @HostBinding('class.display-none') featureGuardElement: boolean = false;
    isVisible: boolean;
    constructor(
        private featureProvider: FeatureProvider) {
        this.isVisible = true;
    }

    ngOnInit() {
        this.featureProvider.getFeatures().then((response: any) => {
            let isFeatureActive = [];

            for (let index = 0; index < this.activatesWith.length; index++) {
                let activatesWith = this.activatesWith[index];

                if (!isFeatureActive.length) {
                    isFeatureActive = filter(response, (obj) => {
                        return obj.Name === activatesWith.AppName && obj.Features.indexOf(activatesWith.FeatureId) > -1;
                    });
                }
            }

            if (!isFeatureActive.length){
                this.featureGuardElement = true;
                this.isVisible = false;
            }
            this.onCheckedFeatureGuard.emit(this.isVisible);
        });
    }

}
